import dynamic from 'next/dynamic';

const WhatsAppFAB = dynamic(() => import('./WhatsAppDropup'));

export default WhatsAppFAB;
